import { render, staticRenderFns } from "./RevisionDictamenes.vue?vue&type=template&id=3624fc30&scoped=true"
import script from "./RevisionDictamenes.vue?vue&type=script&lang=js"
export * from "./RevisionDictamenes.vue?vue&type=script&lang=js"
import style0 from "./RevisionDictamenes.vue?vue&type=style&index=0&id=3624fc30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624fc30",
  null
  
)

export default component.exports